export default __webpack_public_path__ + "static/media/authIllustration.bdc02321.svg";